export const UserSetPass = {
	url: '/set-password?token',
	title: 'Set Password',
	template: '<set-pass-page></set-pass-page>',
	params: {
		token: null,
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "userSetPasswordPageMod" */
			'@Containers/user-set-pass-page/user-set-pass-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
